/** C 端路由 → 所需 ruleList 权限 key */
export const FRONT_ROUTE_RULES = {
  '/typeList': 'goods',
  '/goodList': 'goods',
  '/goodDetail': 'goods',
  '/customer': 'customer',
  '/quotation': 'order_add',
  '/offer': 'order',
  '/offerDetail': 'order_see',
  '/offerEdit': 'order_see',
  '/delivery': 'deliver_goods',
  '/deliveryDetail': 'deliver_goods_see',
  '/factory': 'factory_list',
  '/factoryDetail': 'factory_list',
  '/cuttingPrint': 'factory_list',
  '/orderStats': 'order_stats',
  '/productManage': 'goods_manage',
  '/authManage': 'auth_manage',
  '/memberManage': 'member_manage',
  '/settingsManage': 'settings_manage',
  '/quoteManage': 'quote_manage',
  '/center': 'user',
  '/passSet': 'user',
};

/** 登录后 / 无权限时的落地页优先级（与侧边栏一致，个人中心靠后） */
export const FRONT_LANDING_ROUTES = [
  '/typeList',
  '/customer',
  '/quotation',
  '/offer',
  '/delivery',
  '/factory',
  '/orderStats',
  '/productManage',
  '/authManage',
  '/memberManage',
  '/settingsManage',
  '/quoteManage',
  '/center',
];

export function readRuleList() {
  try {
    return JSON.parse(localStorage.getItem('ruleList') || '{}');
  } catch {
    return {};
  }
}

export function hasFrontRule(ruleList, key) {
  if (!key) return true;
  return !!ruleList[key];
}

export function canAccessFrontRoute(path, ruleList) {
  const key = FRONT_ROUTE_RULES[path];
  if (!key) return true;
  if (hasFrontRule(ruleList, key)) return true;
  if (['auth_manage', 'member_manage', 'settings_manage', 'quote_manage'].includes(key)) {
    return hasFrontRule(ruleList, 'goods_manage');
  }
  return false;
}

/** 按权限返回登录后默认首页；无可用板块时返回 null */
export function resolveDefaultFrontRoute(ruleList) {
  const list = ruleList || readRuleList();
  return FRONT_LANDING_ROUTES.find((path) => canAccessFrontRoute(path, list)) || null;
}
